'use client';
import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from 'recharts';

// Backend integration: replace with /api/jobs/status-summary?date=today
const data = [
  { status: 'Scheduled', count: 5, color: '#818CF8' },
  { status: 'In Transit', count: 3, color: '#38BDF8' },
  { status: 'On Site', count: 2, color: '#A78BFA' },
  { status: 'Returning', count: 4, color: '#F59E0B' },
  { status: 'Completed', count: 9, color: '#34D399' },
  { status: 'Delayed', count: 2, color: '#F87171' },
];

const CustomTooltip = ({ active, payload }: any) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-zinc-900 border border-zinc-700 rounded-lg px-3 py-2 shadow-xl">
      <p className="text-xs text-zinc-400">{payload[0]?.payload?.status}</p>
      <p className="text-sm font-bold text-zinc-100">{payload[0]?.value} jobs</p>
    </div>
  );
};

export default function JobStatusChart() {
  return (
    <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-5 h-full">
      <div className="mb-4">
        <h3 className="text-sm font-semibold text-zinc-200">Jobs by Status</h3>
        <p className="text-xs text-zinc-500 mt-0.5">Today · 25 total jobs</p>
      </div>
      <ResponsiveContainer width="100%" height={200}>
        <BarChart data={data} margin={{ top: 4, right: 4, bottom: 0, left: -25 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="rgb(39 39 42)" vertical={false} />
          <XAxis dataKey="status" tick={{ fontSize: 10, fill: 'rgb(113 113 122)' }} axisLine={false} tickLine={false} />
          <YAxis tick={{ fontSize: 10, fill: 'rgb(113 113 122)' }} axisLine={false} tickLine={false} />
          <Tooltip content={<CustomTooltip />} cursor={{ fill: 'rgba(255,255,255,0.04)' }} />
          <Bar dataKey="count" radius={[4, 4, 0, 0]}>
            {data.map((entry) => (
              <Cell key={`cell-status-${entry.status}`} fill={entry.color} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}